import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Field, Group } from '../../common/index';
import { CREATE_POST, UPDATE_POST, POSTS_FOR_ZONE } from '../../queries/post';

// DateTime <input type="date"> wants YYYY-MM-DD.
const toDateInput = (v) => (v ? new Date(v).toISOString().slice(0, 10) : '');

function PostsForm({ content, onComplete, zoneId }) {
  const [sContent, setSContent] = useState(() => ({
    ...content,
    zoneId: content?.zoneId || zoneId,
    validFrom: toDateInput(content?.validFrom),
    validTo: toDateInput(content?.validTo),
  }));

  const onChange = (patch) => setSContent((prev) => ({ ...prev, ...patch }));

  return (
    <Form
      sContent={sContent}
      add={CREATE_POST}
      update={UPDATE_POST}
      get={POSTS_FOR_ZONE}
      parent="zoneId"
      onComplete={onComplete}
    >
      <Group title="Allmänt">
        <Field type="image" name="imageURL" title="Bild (max 1MB)" value={sContent.imageURL} onChange={onChange} />
        <Field type="text" name="title" title="Titel" value={sContent.title} onChange={onChange} />
        <Field type="textarea" name="text" title="Text" value={sContent.text} onChange={onChange} rows={3} />
      </Group>
      <Group title="Knapp">
        <Field type="text" name="buttonLabel" title="Knapptext" value={sContent.buttonLabel} onChange={onChange} />
        <Field type="text" name="buttonLink" title="Knapplänk (URL)" value={sContent.buttonLink} onChange={onChange} />
      </Group>
      <Group title="Giltig">
        <Field type="date" name="validFrom" title="Giltig från" value={sContent.validFrom} onChange={onChange} req />
        <Field type="date" name="validTo" title="Giltig till" value={sContent.validTo} onChange={onChange} req />
      </Group>
    </Form>
  );
}

PostsForm.propTypes = {
  content: PropTypes.object,
  onComplete: PropTypes.func.isRequired,
  zoneId: PropTypes.string.isRequired,
};

export default PostsForm;
